// removed by extract-text-webpack-plugin
module.exports = {"NewGameButton":"_3q35joUF9_VN1dzZnIlP1h"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/NewGameButton/NewGameButton.scss
 ** module id = 396
 ** module chunks = 1
 **/